import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  whileInView: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  },
  viewport: {
    once: true,
    margin: '-100px'
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  whileInView: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  },
  viewport: {
    once: true,
    margin: '-50px'
  }
};
export function AudienceSection() {
  const whoFor = ['Mujeres profesionales de más de 40 años que enfrentan reuniones y presentaciones.', 'Mujeres latinas en USA que quieren soluciones prácticas y directas, no teorías médicas.', 'Quienes sienten que la menopausia está afectando su seguridad al interactuar con otros.', 'Mujeres que buscan un método natural y discreto para recuperar el control inmediato.'];
  const whoNotFor = ['Personas que buscan una cura médica permanente o reemplazo hormonal (esto es una herramienta táctica).', 'Quienes no están dispuestas a practicar una técnica de respiración de 90 segundos.', 'Personas que prefieren esperar años a que los síntomas desaparezcan por sí solos.'];
  const steps = ['Descargas el manual en tu teléfono o computadora.', 'Aprendes la técnica del "Interruptor" y armas tu kit de bolso en 10 minutos.', 'La próxima vez que sientas el calor, aplicas el protocolo y ves cómo el incendio se apaga antes de empezar.'];
  return <>
      {/* Who This Is For & Not For */}
      <section className="bg-brand-sage py-24 px-6" data-id="element-7">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-8">
          <motion.div initial="hidden" whileInView="whileInView" viewport={{
          once: true
        }} variants={fadeInUp} className="bg-white p-10 rounded-3xl shadow-sm" data-id="element-9">
            <h2 className="font-serif text-3xl font-bold text-brand-teal mb-8" data-id="element-10">
              Para quién es esto
            </h2>
            <ul className="space-y-6" data-id="element-11">
              {whoFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-12">
                  <div className="bg-brand-sage p-1 rounded-full shrink-0 mt-1" data-id="element-13">
                    <Check className="w-5 h-5 text-brand-teal" data-id="element-14" />
                  </div>
                  <span className="font-sans text-brand-charcoal/90 leading-relaxed" data-id="element-15">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial="hidden" whileInView="whileInView" viewport={{
          once: true
        }} variants={fadeInUp} className="bg-brand-cream p-10 rounded-3xl border border-brand-charcoal/5" data-id="element-16">
            <h2 className="font-serif text-3xl font-bold text-brand-charcoal/60 mb-8" data-id="element-17">
              Para quién NO es
            </h2>
            <ul className="space-y-6" data-id="element-18">
              {whoNotFor.map((item, index) => <li key={index} className="flex items-start gap-4 opacity-70" data-id="element-19">
                  <div className="bg-brand-charcoal/10 p-1 rounded-full shrink-0 mt-1" data-id="element-20">
                    <X className="w-5 h-5 text-brand-charcoal" data-id="element-21" />
                  </div>
                  <span className="font-sans text-brand-charcoal leading-relaxed" data-id="element-22">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </section>

      {/* How It Works */}
      <section className="bg-brand-cream py-24 px-6" data-id="element-23">
        <div className="max-w-4xl mx-auto" data-id="element-24">
          <motion.h2 initial="hidden" whileInView="whileInView" viewport={{
          once: true
        }} variants={fadeInUp} className="font-serif text-3xl md:text-4xl font-bold text-brand-charcoal mb-16 text-center" data-id="element-25">
            Cómo funciona
          </motion.h2>

          <motion.div variants={staggerContainer} initial="hidden" whileInView="whileInView" className="space-y-12 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-brand-sage" data-id="element-26">
            {steps.map((step, index) => <motion.div key={index} variants={fadeInUp} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-27">
                <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-brand-cream bg-brand-teal text-white font-serif font-bold text-xl shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-md z-10" data-id="element-28">
                  {index + 1}
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-2xl shadow-sm border border-brand-sage/30" data-id="element-29">
                  <p className="font-sans text-lg text-brand-charcoal/90 leading-relaxed" data-id="element-30">
                    {step}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </section>
    </>;
}